import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import axios from "axios"

Vue.use(ElementUI);
Vue.use(VueRouter);

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: '6Q1kP74uEi51AkBX5aVzufsctvKpOo0e'
})

import index from './views/index.vue'
import FacscopeB from './views/FacscopeB.vue';
import CellogerStack from './views/CellogerStack.vue';
import ContactUs from './views/ContactUs.vue';
import CellogerNano from './views/CellogerNano.vue';
import Cellpuri from './views/Cellpuri.vue';
import CellogerPro from './views/CellogerPro.vue';
import CellogerMiniPlus from './views/CellogerMiniPlus.vue';
import ProductCenter from './views/ProductCenter.vue';
import Slide from './views/Slide.vue';
import Reference from './views/Reference.vue';
import MixedCells from './views/MixedCells.vue';

let routes = [
	{path:"/",component:index,meta: {title: "上海康和达生物技术有限公司"}},
	{path:"/FacscopeB",component:FacscopeB,meta: {title: "FacscopeB-自动细胞计数仪-细胞计数 | 康和达生物 韩国Curiosis品牌"}},
	{path:"/CellogerNano",component:CellogerNano,meta: {title: "CellogerNano-活细胞影像仪-延时成像 | 康和达生物 韩国Curiosis品牌"}},
	{path:"/CellogerMiniPlus",component:CellogerMiniPlus,meta: {title: "CellogerMiniPlus-全自动活细胞成像分析系统-活细胞成像 | 康和达生物 韩国Curiosis品牌"}},
	{path:"/CellogerPro",component:CellogerPro,meta: {title: "CellogerPro-全自动活细胞成像分析系统-活细胞成像 | 康和达生物 韩国Curiosis品牌"}},
	{path:"/CellogerStack",component:CellogerStack,meta: {title: "CellogerStack-全自动细胞工厂成像仪-细胞工厂 | 康和达生物 韩国Curiosis品牌"}},
	{path:"/Cellpuri",component:Cellpuri,meta: {title: "Cellpuri-一次性细胞富集芯片-富集细胞-分离细胞 | 康和达生物 韩国Curiosis品牌"}},
	{path:"/ContactUs",component:ContactUs,meta: {title: "联系我们和申请试用 | 康和达生物"}},
	{path:"/MixedCells",component:MixedCells,meta: {title: "混合细胞-病毒分离培养-呼吸道病毒-肠道病毒 | 康和达生物"}},
	{path:"/Slide",component:Slide,meta: {title: "自动细胞计数板-一次性计数板-血细胞计数板 | 康和达生物 韩国Curiosis品牌"}},
	{path:"/ProductCenter",component:ProductCenter,meta: {title: "产品中心 | 康和达生物"}},
	{path:"/Reference",component:Reference,meta: {title: "引用文献 | 康和达生物"}},
]

let router = new VueRouter({
	mode: 'history',
	routes,
	scrollBehavior(to, from, savedPosition) {
	// 带锚点的目标（如「申请试用」跳到样机试用申请表单）滚到对应元素，
	// 偏移 100px 让开固定在顶部的页头；其余情况一律回到顶部
	if (to.hash) {
		return { selector: to.hash, offset: { x: 0, y: 100 } };
	}
	return { x: 0, y: 0 };
	}
})

router.beforeEach((to, from, next) => {
	// 路由发生变化修改页面title 
	if (to.meta.title) {
		document.title = to.meta.title;
		next();
	}
});

axios.defaults.baseURL = '/api';

new Vue({
	 el: '#app',
	 router,
	 store,
  render: h => h(App),
}).$mount('#app')
